(function () {
  function parseJsonScript(el) {
    if (!el) {
      throw new Error('gelato-poster-configurator: chybí JSON script element');
    }
    return JSON.parse(el.textContent);
  }

  function displayLabel(config, value) {
    if (!value) {
      return '';
    }
    const labels = config.valueDisplayLabels;
    if (!labels || typeof labels !== 'object') {
      throw new Error('gelato-poster-configurator: chybí valueDisplayLabels v config');
    }
    if (Object.prototype.hasOwnProperty.call(labels, value)) {
      return labels[value];
    }
    return value;
  }

  function optionKeyFromPosition(position, fieldName) {
    const pos = Number(position);
    if (![1, 2, 3].includes(pos)) {
      throw new Error('gelato-poster-configurator: neplatná ' + fieldName + ': ' + String(position));
    }
    return 'option' + pos;
  }

  function sizeCodeFromOptionValue(value) {
    const text = value || '';
    if (text.indexOf('A3') !== -1) {
      return 'A3';
    }
    if (text.indexOf('21x29.7') !== -1) {
      return 'A4';
    }
    throw new Error('gelato-poster-configurator: neznámý size option value: ' + text);
  }

  function orientationFromOptionValue(value) {
    const text = value || '';
    if (text.indexOf('Horizontal') !== -1) {
      return 'Horizontal';
    }
    if (text.indexOf('Vertical') !== -1) {
      return 'Vertical';
    }
    throw new Error('gelato-poster-configurator: neznámá orientace v size option: ' + text);
  }

  /**
   * Admin Orientation - Size → { orientationLabel, sizeLabel }
   * "Vertical - A3 (29.7 x 42  cm)" → Vertikální + A3 (29.7 x 42 cm)
   * "Horizontal - 21x29.7 cm / 8x12\"" → Horizontální + A4 (21 x 29.7 cm)
   */
  function parseOrientationSizeParts(optionValue, combinationLabels) {
    const text = String(optionValue || '');
    const labels = combinationLabels || {};
    let orientationLabel;
    if (text.indexOf('Horizontal') !== -1) {
      orientationLabel = labels.horizontal;
    } else if (text.indexOf('Vertical') !== -1) {
      orientationLabel = labels.vertical;
    } else {
      throw new Error('gelato-poster-configurator: neznámá orientace v size label: ' + text);
    }
    if (!orientationLabel) {
      throw new Error('gelato-poster-configurator: chybí překlad orientace v combinationLabels');
    }

    let sizeLabel;
    if (text.indexOf('A3') !== -1) {
      const dimsMatch = text.match(/\(([^)]+)\)/);
      if (!dimsMatch) {
        throw new Error('gelato-poster-configurator: A3 option bez rozměrů v závorce: ' + text);
      }
      const dims = dimsMatch[1].replace(/\s+/g, ' ').trim();
      sizeLabel = 'A3 (' + dims + ')';
    } else if (text.indexOf('21x29.7') !== -1) {
      sizeLabel = 'A4 (21 x 29.7 cm)';
    } else {
      throw new Error('gelato-poster-configurator: neznámý size option value pro label: ' + text);
    }

    return { orientationLabel: orientationLabel, sizeLabel: sizeLabel };
  }

  function preferHorizontalDesign(design) {
    const handle = String(design || '').toLowerCase();
    return handle === 'map' || handle === 'mapa';
  }

  function findVariant(product, selections) {
    return product.variants.find(function (variant) {
      return variant.option1 === selections.option1 &&
        variant.option2 === selections.option2 &&
        variant.option3 === selections.option3;
    });
  }

  class GelatoPosterConfigurator {
    constructor(root) {
      this.root = root;
      this.config = parseJsonScript(root.querySelector('[data-gelato-poster-config]'));
      this.productJsonEl = document.querySelector(this.config.productJsonSelector);
      if (!this.productJsonEl) {
        throw new Error('gelato-poster-configurator: nenalezen ProductJson pro ' + this.config.productJsonSelector);
      }
      this.product = parseJsonScript(this.productJsonEl);
      this.form = root.querySelector('[data-product-form]');
      this.errorEl = root.querySelector('[data-gelato-poster-error]');
      this.productScope = this.root.closest('[data-product]') || this.root;
      this.selectedLabelEl = root.querySelector('[data-gelato-poster-selected]');
      this.selectionSummaryEl = root.querySelector('[data-gelato-poster-selection-summary]');
      this.galleryComboBadge = this.productScope.querySelector('[data-gelato-poster-gallery-combo]');
      this.galleryComboTextEl = this.galleryComboBadge
        ? this.galleryComboBadge.querySelector('[data-gelato-poster-gallery-combo-text]')
        : null;
      this.previewHost = document.querySelector('[data-gelato-poster-preview-host]');
      this.variantMediaMapEl = document.querySelector('[data-gelato-poster-variant-media-map]');
      this.variantMediaMap = this.variantMediaMapEl ? parseJsonScript(this.variantMediaMapEl) : {};
      this.variantInput = root.querySelector('[data-gelato-poster-variant-id]');
      this.atcButton = root.querySelector('[data-gelato-poster-atc]');
      this.atcTextEl = root.querySelector('[data-add-to-cart-text]');
      this.optionInputs = Array.from(root.querySelectorAll('[data-gelato-poster-option]'));
      this.sizeIndex = optionKeyFromPosition(this.config.sizeOptionPosition, 'sizeOptionPosition');
      this.frameIndex = optionKeyFromPosition(this.config.frameOptionPosition, 'frameOptionPosition');
      this.designIndex = optionKeyFromPosition(this.config.designOptionPosition, 'designOptionPosition');
      this.sizeCode = null;
      this.frameValue = null;
      this.designValue = null;
      this.galleryDefaultOrder = null;
      this.heroOriginalSnapshot = null;
      this.sideOriginalSnapshot = null;
      this.currentSideMediaId = null;
      this.lastPromotedVariant = null;
      this.sideSwapToken = 0;
      this.galleryWasMobile = null;
      this.snapshotCache = Object.create(null);
      this.prefetchedUrls = Object.create(null);
      this.defaultVisibleCount = 6;
      this.defaultGalleryApplied = false;
      this.lockedMobileViewportHeight = null;
      this.selections = {
        option1: null,
        option2: null,
        option3: null,
      };

      this.suppressThemeMediaSelect = false;
      this.allowGallerySelect = false;
      this.lastEnabledVariant = null;
      this.scrollMode = null;
      this.gallerySpacer = null;
      this.stickyHeroStack = null;
      this.heroPinnedHeight = null;
      this.lockedGalleryPaddingTop = null;
      this.lastScrollY = 0;
      this.stickyAtcBar = null;
      this.stickyAtcBtn = null;
      this.stickyAtcBottom = null;
      this.stickyAtcBottomBtn = null;
      this.stickyChrome = null;
      this.stickyChromeTitle = null;
      this.sectionScrollReleased = false;
      this.sectionReleaseScrollY = 0;
      this.sectionReleaseHeroH = 0;
      this.scrollChromeRaf = 0;
      this.cachedTitleHeight = 0;
      this.cachedBadgeHeight = 0;
      this.chromeInlinePadPx = null;
      this.onMobileScrollChrome = this.scheduleMobileScrollChrome.bind(this);

      // Theme ProductForm.updateAddToCartState přidá cenu do ATC jen když je tento flag true.
      // Bez něj syncHiddenInputs → change přepíše Gelato label na holé „Do košíku“.
      if (this.config.showPriceInButton) {
        window.theme = window.theme || {};
        window.theme.settings = window.theme.settings || {};
        window.theme.settings.atcButtonShowPrice = true;
      }

      this.bindUi();
      this.onGalleryResize = () => {
        this.lockedMobileViewportHeight = null;
        // Aspect lock drž — jen výšku viewportu přeměř po změně šířky
        this.syncHeaderOffset();
        window.setTimeout(() => this.syncGalleryLayout(), 50);
        window.setTimeout(() => this.updateMobileScrollChrome(), 60);
      };
      window.addEventListener('theme:resize:width', this.onGalleryResize);
      this.updateAvailability();
      this.initEmptyState();
      this.bindThemePriceGuard();
      this.initMobileMetaCollapse();
      this.ensureMobileBadgePlacement();
      this.initMobileScrollChrome();
      document.documentElement.classList.add('gelato-poster-configurator--active');
      this.root.closest('[data-product]')?.classList.add('gelato-poster-configurator--active');
      // Theme Flickity na mobilu startuje async — znovu omezíme slides po jeho init.
      window.setTimeout(() => this.syncGalleryLayout(), 0);
      window.setTimeout(() => this.syncGalleryLayout(), 250);
      window.setTimeout(() => this.syncGalleryLayout(), 800);
      window.setTimeout(() => this.updateMobileScrollChrome(), 100);
      window.setTimeout(() => this.updateMobileScrollChrome(), 400);
      // Theme ProductForm po init přepíše cenu na 0,00 Kč — znovu „Od …“.
      window.setTimeout(() => this.reassertProductPriceDisplay(), 0);
      window.setTimeout(() => this.reassertProductPriceDisplay(), 50);
      window.setTimeout(() => this.reassertProductPriceDisplay(), 200);
      window.setTimeout(() => this.reassertProductPriceDisplay(), 500);
    }

    getGalleryRoot() {
      return this.productScope.querySelector('.product-single__gallery');
    }

    ensureGallerySpacer() {
      const gallery = this.getGalleryRoot();
      if (!gallery) {
        return null;
      }
      if (this.gallerySpacer && this.gallerySpacer.isConnected) {
        return this.gallerySpacer;
      }
      const spacer = document.createElement('div');
      spacer.className = 'gelato-poster-gallery-spacer';
      spacer.setAttribute('aria-hidden', 'true');
      gallery.parentNode.insertBefore(spacer, gallery);
      this.gallerySpacer = spacer;
      return spacer;
    }

    /**
     * Mobil: sticky hero = fotka; badge POD fotkou (nepřekrývá náhled).
     * Flickity viewport nehýbat — jen obalit.
     */
    ensureMobileBadgePlacement() {
      if (!this.isMobileGallery()) {
        this.unwrapStickyHeroStack();
        return;
      }
      const slider = this.getGallerySlider();
      const badge = this.galleryComboBadge;
      if (!slider || !slider.parentNode) {
        return;
      }
      this.ensureStickyHeroStack(slider, badge);
    }

    ensureStickyHeroStack(slider, badge) {
      const gallery = this.getGalleryRoot();
      if (!gallery || !slider) {
        return null;
      }
      let stack =
        this.stickyHeroStack ||
        gallery.querySelector('[data-gelato-sticky-hero]');
      if (!stack) {
        stack = document.createElement('div');
        stack.className = 'gelato-poster-sticky-hero';
        stack.setAttribute('data-gelato-sticky-hero', 'true');
        slider.parentNode.insertBefore(stack, slider);
      }

      let frame = stack.querySelector('[data-gelato-sticky-hero-frame]');
      if (!frame) {
        frame = document.createElement('div');
        frame.className = 'gelato-poster-sticky-hero__frame';
        frame.setAttribute('data-gelato-sticky-hero-frame', 'true');
      }

      // Motion = fotka + „Zvolená kombinace“ — společný scale (roztahuje se spolu, neskáče).
      let motion = stack.querySelector('[data-gelato-hero-motion]');
      if (!motion) {
        motion = document.createElement('div');
        motion.className = 'gelato-poster-sticky-hero__motion';
        motion.setAttribute('data-gelato-hero-motion', 'true');
        stack.appendChild(motion);
      }
      if (frame.parentNode !== motion) {
        motion.appendChild(frame);
      }
      if (slider.parentNode !== frame) {
        frame.appendChild(slider);
      }
      if (badge) {
        badge.style.transform = '';
        badge.style.marginTop = '';
        if (badge.parentNode !== motion || badge.previousElementSibling !== frame) {
          motion.insertBefore(badge, frame.nextSibling);
        }
      }
      this.stickyHeroStack = stack;
      return stack;
    }

    unwrapStickyHeroStack() {
      const gallery = this.getGalleryRoot();
      const stack =
        this.stickyHeroStack ||
        (gallery && gallery.querySelector('[data-gelato-sticky-hero]'));
      if (!stack || !stack.parentNode) {
        this.stickyHeroStack = null;
        return;
      }
      const parent = stack.parentNode;
      const frame = stack.querySelector('[data-gelato-sticky-hero-frame]');
      const moveOut = (node) => {
        if (!node) {
          return;
        }
        while (node.firstChild) {
          parent.insertBefore(node.firstChild, stack);
        }
      };
      if (frame) {
        moveOut(frame);
      }
      while (stack.firstChild) {
        parent.insertBefore(stack.firstChild, stack);
      }
      parent.removeChild(stack);
      this.stickyHeroStack = null;
    }

    getAtcHolder() {
      return (
        this.root.querySelector('.product__submit__holder') ||
        (this.atcButton && this.atcButton.closest('.product__submit__holder')) ||
        null
      );
    }

    getProductTitleEl() {
      return this.productScope.querySelector('.product-single__details .product__title');
    }

    getProductTitleBlock() {
      return this.productScope.querySelector(
        '.product-single__details .product__title-and-price'
      );
    }

    clearTitleSticky() {
      const titleBlock = this.getProductTitleBlock();
      if (titleBlock) {
        titleBlock.classList.remove(
          'gelato-poster-title--sticky',
          'gelato-poster-title--fixed',
          'gelato-poster-title--in-chrome',
          'is-stuck',
          'is-pinned'
        );
        titleBlock.style.top = '';
        titleBlock.style.left = '';
        titleBlock.style.right = '';
        titleBlock.style.width = '';
        titleBlock.style.visibility = '';
      }
      document.documentElement.style.removeProperty('--gelato-title-sticky-top');
      this.destroyTitleFixedSpacer();
      this.destroyStickyChrome();
      document.querySelectorAll('[data-gelato-sticky-chrome], [data-gelato-sticky-atc-bottom]').forEach(function (el) {
        if (el.parentNode) {
          el.parentNode.removeChild(el);
        }
      });
    }

    ensureTitleFixedSpacer(titleBlock) {
      if (!titleBlock || !titleBlock.parentNode) {
        return null;
      }
      let spacer = titleBlock.parentNode.querySelector('[data-gelato-title-spacer]');
      if (!spacer) {
        spacer = document.createElement('div');
        spacer.className = 'gelato-poster-title-spacer';
        spacer.setAttribute('data-gelato-title-spacer', 'true');
        titleBlock.parentNode.insertBefore(spacer, titleBlock);
      }
      const h = this.cachedTitleHeight || Math.round(titleBlock.offsetHeight) || 0;
      if (h > 0) {
        this.cachedTitleHeight = h;
        spacer.style.height = h + 'px';
      }
      return spacer;
    }

    destroyTitleFixedSpacer() {
      document.querySelectorAll('[data-gelato-title-spacer]').forEach(function (el) {
        if (el.parentNode) {
          el.parentNode.removeChild(el);
        }
      });
    }

    /**
     * Title+ATC na document.body — fixed uvnitř product section se u footeru
     * váže na transformovaný ancestor a text se ořezává.
     */
    ensureStickyChrome() {
      if (this.stickyChrome && this.stickyChrome.isConnected) {
        return this.stickyChrome;
      }
      const chrome = document.createElement('div');
      chrome.className = 'gelato-poster-sticky-chrome';
      chrome.setAttribute('data-gelato-sticky-chrome', 'true');
      chrome.hidden = true;

      const titleEl = document.createElement('div');
      titleEl.className = 'gelato-poster-sticky-chrome__title';
      titleEl.setAttribute('data-gelato-sticky-chrome-title', 'true');
      chrome.appendChild(titleEl);

      const atcWrap = document.createElement('div');
      atcWrap.className = 'gelato-poster-sticky-atc';
      atcWrap.setAttribute('data-gelato-sticky-atc', 'true');

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gelato-poster-sticky-atc__btn btn btn--large btn--submit';
      btn.addEventListener('click', () => {
        if (!this.isComplete()) {
          this.scrollToDesignSelection();
          return;
        }
        if (this.atcButton && !this.atcButton.disabled) {
          this.atcButton.click();
        }
      });
      atcWrap.appendChild(btn);
      chrome.appendChild(atcWrap);

      document.body.appendChild(chrome);
      this.stickyChrome = chrome;
      this.stickyChromeTitle = titleEl;
      this.stickyAtcBar = atcWrap;
      this.stickyAtcBtn = btn;
      this.syncStickyChrome();
      return chrome;
    }

    destroyStickyChrome() {
      if (this.stickyChrome && this.stickyChrome.parentNode) {
        this.stickyChrome.parentNode.removeChild(this.stickyChrome);
      }
      this.stickyChrome = null;
      this.stickyChromeTitle = null;
      this.stickyAtcBar = null;
      this.stickyAtcBtn = null;
      this.destroyStickyAtcBottom();
    }

    destroyStickyAtcBar() {
      this.destroyStickyChrome();
    }

    /**
     * Spodní sticky ATC (mobil) — dokud je pravé ATC pod foldem.
     * Po meet s title → skryje se, horní chrome převezme (už hotové).
     */
    ensureStickyAtcBottom() {
      if (this.stickyAtcBottom && this.stickyAtcBottom.isConnected) {
        return this.stickyAtcBottom;
      }
      const bar = document.createElement('div');
      bar.className = 'gelato-poster-sticky-atc-bottom';
      bar.setAttribute('data-gelato-sticky-atc-bottom', 'true');
      bar.hidden = true;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gelato-poster-sticky-atc__btn btn btn--large btn--submit';
      btn.addEventListener('click', () => {
        if (!this.isComplete()) {
          this.scrollToDesignSelection();
          return;
        }
        if (this.atcButton && !this.atcButton.disabled) {
          this.atcButton.click();
        }
      });
      bar.appendChild(btn);
      document.body.appendChild(bar);
      this.stickyAtcBottom = bar;
      this.stickyAtcBottomBtn = btn;
      this.syncStickyAtcBar();
      return bar;
    }

    destroyStickyAtcBottom() {
      if (this.stickyAtcBottom && this.stickyAtcBottom.parentNode) {
        this.stickyAtcBottom.parentNode.removeChild(this.stickyAtcBottom);
      }
      this.stickyAtcBottom = null;
      this.stickyAtcBottomBtn = null;
      document.documentElement.classList.remove('gelato-poster-atc-bottom--visible');
    }

    showStickyAtcBottom() {
      const bar = this.ensureStickyAtcBottom();
      this.syncStickyChromeInlinePad();
      this.syncStickyAtcBar();
      bar.hidden = false;
      bar.classList.add('is-visible');
      document.documentElement.classList.add('gelato-poster-atc-bottom--visible');
    }

    hideStickyAtcBottom() {
      if (this.stickyAtcBottom) {
        this.stickyAtcBottom.hidden = true;
        this.stickyAtcBottom.classList.remove('is-visible');
      }
      document.documentElement.classList.remove('gelato-poster-atc-bottom--visible');
    }

    /**
     * Spodní ATC vidět jen když je flow ATC pod viewportem a horní chrome ještě neběží.
     */
    updateStickyAtcBottom() {
      if (!this.isMobileGallery() || !this.atcButton) {
        this.hideStickyAtcBottom();
        return;
      }
      const topChromeOn =
        this.sectionScrollReleased ||
        (this.stickyChrome &&
          !this.stickyChrome.hidden &&
          this.stickyChrome.classList.contains('is-visible'));
      if (topChromeOn) {
        this.hideStickyAtcBottom();
        return;
      }
      const holder = this.getAtcHolder();
      if (!holder) {
        this.hideStickyAtcBottom();
        return;
      }
      const rect = holder.getBoundingClientRect();
      const vh = window.innerHeight || 0;
      // ATC ještě pod foldem → spodní sticky; jakmile vleze do viewportu, zmizí.
      if (rect.top >= vh - 4) {
        this.showStickyAtcBottom();
        return;
      }
      this.hideStickyAtcBottom();
    }

    syncStickyChrome() {
      const titleBlock = this.getProductTitleBlock();
      if (this.stickyChromeTitle && titleBlock) {
        const titleEl = titleBlock.querySelector('.product__title') || titleBlock;
        this.stickyChromeTitle.textContent = (titleEl.textContent || '').trim();
        const align = window.getComputedStyle(titleEl).textAlign || 'start';
        this.stickyChromeTitle.style.textAlign = align;
      }
      this.syncStickyAtcBar();
    }

    syncStickyAtcBar() {
      const needsSelection =
        this.atcButton && this.atcButton.hasAttribute('data-gelato-atc-needs-selection');
      const disabled = !!(
        this.atcButton &&
        this.atcButton.disabled &&
        !needsSelection
      );
      const apply = (btn) => {
        if (!btn) {
          return;
        }
        if (this.atcTextEl) {
          btn.innerHTML = this.atcTextEl.innerHTML;
        } else if (this.atcButton) {
          btn.textContent = (this.atcButton.textContent || '').trim();
        }
        btn.disabled = disabled;
      };
      apply(this.stickyAtcBtn);
      apply(this.stickyAtcBottomBtn);
    }

    /**
     * Horizontální inset = stejný jako title v flow (chrome, ATC, badge kombinace).
     */
    syncStickyChromeInlinePad(titleBlock) {
      const block = titleBlock || this.getProductTitleBlock();
      if (this.chromeInlinePadPx == null && block) {
        const rect = block.getBoundingClientRect();
        const cs = window.getComputedStyle(block);
        const padL = parseFloat(cs.paddingLeft) || 0;
        // Text začíná na left + paddingLeft contentu v flow
        const measured = Math.max(0, Math.round(rect.left + padL));
        if (measured > 0) {
          this.chromeInlinePadPx = measured;
        }
      }
      if (this.chromeInlinePadPx == null) {
        const details =
          this.productScope &&
          this.productScope.querySelector('.product-single__details');
        if (details) {
          const pad = parseFloat(window.getComputedStyle(details).paddingLeft);
          if (Number.isFinite(pad) && pad > 0) {
            this.chromeInlinePadPx = Math.round(pad);
          }
        }
      }
      const pad =
        this.chromeInlinePadPx != null
          ? this.chromeInlinePadPx + 'px'
          : 'var(--gutter-mobile, 20px)';
      document.documentElement.style.setProperty('--gelato-chrome-inline', pad);
      if (this.stickyChrome) {
        this.stickyChrome.style.setProperty('--gelato-chrome-inline', pad);
      }
      if (this.stickyAtcBottom) {
        this.stickyAtcBottom.style.setProperty('--gelato-chrome-inline', pad);
      }
    }

    showStickyChrome(chromeTop) {
      // Přelití: spodní ATC pryč, horní chrome bere CTA.
      this.hideStickyAtcBottom();
      const chrome = this.ensureStickyChrome();
      const titleBlock = this.getProductTitleBlock();
      const holder = this.getAtcHolder();
      // Pad změř PŘED skrytím title (jinak left skočí)
      this.syncStickyChromeInlinePad(titleBlock);
      this.syncStickyChrome();
      if (titleBlock) {
        if (!this.cachedTitleHeight) {
          this.cachedTitleHeight = Math.round(titleBlock.offsetHeight) || 0;
        }
        this.ensureTitleFixedSpacer(titleBlock);
        titleBlock.classList.add('gelato-poster-title--in-chrome');
        titleBlock.style.visibility = 'hidden';
      }
      chrome.hidden = false;
      chrome.classList.add('is-visible');
      chrome.style.top = Math.round(chromeTop || 0) + 'px';
      if (holder) {
        holder.classList.add('gelato-poster-atc--in-sticky');
      }
    }

    hideStickyChrome() {
      if (this.stickyChrome) {
        this.stickyChrome.hidden = true;
        this.stickyChrome.classList.remove('is-visible');
        this.stickyChrome.style.top = '';
        this.stickyChrome.style.removeProperty('--gelato-chrome-inline');
      }
      // chromeInlinePadPx nech — badge kombinace drží stejný inline i po unpin
      const titleBlock = this.getProductTitleBlock();
      if (titleBlock) {
        titleBlock.classList.remove('gelato-poster-title--in-chrome', 'gelato-poster-title--fixed');
        titleBlock.style.visibility = '';
      }
      this.destroyTitleFixedSpacer();
      const holder = this.getAtcHolder();
      if (holder) {
        holder.classList.remove('gelato-poster-atc--in-sticky');
      }
      this.syncStickyChromeInlinePad(titleBlock);
      this.updateStickyAtcBottom();
    }

    unpinReleasedSection(stack) {
      this.sectionScrollReleased = false;
      this.sectionReleaseScrollY = 0;
      this.sectionReleaseHeroH = 0;
      if (stack) {
        stack.style.transform = 'translate3d(0, 0, 0)';
        stack.style.pointerEvents = '';
      }
      this.hideStickyChrome();
    }

    /**
     * ATC nalepí na title při meet → chrome (title+ATC) na body.
     * Další scroll = peel (hero+title odjedou, ATC skončí fixed nahoře).
     * Scroll zpět = stejný peel reverzně; pod pinY = unpin do flow.
     */
    updateStickyAtcWithTitle() {
      const holder = this.getAtcHolder();
      const titleBlock = this.getProductTitleBlock();
      if (!this.isMobileGallery() || !holder || !this.atcButton || !titleBlock) {
        this.hideStickyChrome();
        this.destroyStickyChrome();
        this.hideStickyAtcBottom();
        return;
      }

      if (this.sectionScrollReleased) {
        if (!this.stickyChrome || this.stickyChrome.hidden) {
          const top = Math.max(0, Math.round(titleBlock.getBoundingClientRect().top));
          this.showStickyChrome(top);
        } else {
          this.syncStickyChrome();
          holder.classList.add('gelato-poster-atc--in-sticky');
        }
        this.hideStickyAtcBottom();
        return;
      }

      const titlePinned = titleBlock.classList.contains('is-pinned');
      const titleRect = titleBlock.getBoundingClientRect();
      const atcTop = holder.getBoundingClientRect().top;
      const meetsTitle = atcTop <= titleRect.bottom + 1;

      if (titlePinned && meetsTitle) {
        const stack =
          this.stickyHeroStack ||
          document.querySelector('[data-gelato-sticky-hero]');
        const dockTop = Math.max(0, Math.round(titleRect.top));
        this.sectionScrollReleased = true;
        this.sectionReleaseScrollY =
          window.pageYOffset || document.documentElement.scrollTop || 0;
        // Výška peel startu = skutečný top title (pod hero), ne odhad
        this.sectionReleaseHeroH =
          dockTop ||
          this.heroPinnedHeight ||
          this.lockedMobileViewportHeight ||
          Math.round((window.innerHeight || 1) * 0.4);
        this.cachedTitleHeight = Math.round(titleBlock.offsetHeight) || 0;
        this.showStickyChrome(dockTop);
        if (stack) {
          stack.style.transform = 'translate3d(0, 0, 0)';
        }
        this.hideStickyAtcBottom();
        return;
      }

      this.hideStickyChrome();
      this.updateStickyAtcBottom();
    }

    /**
     * Title sticky pod hero. Po pin ATC řídí peel updateReleasedSectionMotion.
     */
    updateTopStickyChrome() {
      if (!this.isMobileGallery()) {
        this.clearTitleSticky();
        return;
      }

      const titleBlock = this.getProductTitleBlock();
      if (!titleBlock) {
        this.updateStickyAtcWithTitle();
        return;
      }

      if (this.sectionScrollReleased) {
        this.updateStickyAtcWithTitle();
        return;
      }

      const stack =
        this.stickyHeroStack ||
        document.querySelector('[data-gelato-sticky-hero]');
      let dockTop = 0;
      if (stack && stack.classList.contains('gelato-poster-hero-fixed')) {
        const motion = stack.querySelector('[data-gelato-hero-motion]');
        const rect = (motion || stack).getBoundingClientRect();
        dockTop = Math.max(0, Math.round(rect.bottom));
      }

      titleBlock.classList.add('gelato-poster-title--sticky');
      titleBlock.classList.remove('gelato-poster-title--fixed', 'gelato-poster-title--in-chrome');
      titleBlock.style.visibility = '';
      titleBlock.style.top = dockTop + 'px';
      document.documentElement.style.setProperty(
        '--gelato-title-sticky-top',
        dockTop + 'px'
      );

      const titleTop = titleBlock.getBoundingClientRect().top;
      const pinned = titleTop <= dockTop + 1;
      titleBlock.classList.toggle('is-pinned', pinned);
      titleBlock.classList.toggle('is-stuck', pinned && dockTop <= 2);

      this.updateStickyAtcWithTitle();
    }

    /**
     * Desktop grid layout vyžaduje přímé children slides — Flickity to rozbije.
     */
    destroyDesktopFlickity(slider) {
      const flickityApi = this.getFlickityApi();
      if (!flickityApi) {
        return;
      }
      const targets = [slider, this.getThumbsSlider()].filter(Boolean);
      targets.forEach(function (el) {
        const flkty = flickityApi.data(el);
        if (flkty && typeof flkty.destroy === 'function') {
          flkty.destroy();
        }
      });
    }

    initMobileScrollChrome() {
      if (!this.isMobileGallery()) {
        this.setMobileScrollMode('desktop');
        return;
      }
      this.syncHeaderOffset();
      this.syncStickyChromeInlinePad();
      this.ensureMobileBadgePlacement();
      window.addEventListener('scroll', this.onMobileScrollChrome, { passive: true });
      document.addEventListener('theme:scroll', this.onMobileScrollChrome);
      this.setMobileScrollMode('top');
      this.updateMobileScrollChrome();
    }

    scheduleMobileScrollChrome() {
      if (this.scrollChromeRaf) {
        return;
      }
      const self = this;
      this.scrollChromeRaf = window.requestAnimationFrame(function () {
        self.scrollChromeRaf = 0;
        self.updateMobileScrollChrome();
      });
    }

    clamp01(value) {
      if (value <= 0) {
        return 0;
      }
      if (value >= 1) {
        return 1;
      }
      return value;
    }

    /**
     * Výška shop headeru — chrome/hero dokují pod ním (header je vždy fixed).
     */
    syncHeaderOffset() {
      const header = document.querySelector('.site-header');
      let offset = 0;
      if (header) {
        offset = Math.round(header.getBoundingClientRect().height) || 0;
      }
      if (!offset) {
        const cssVal = parseInt(
          window.getComputedStyle(document.documentElement).getPropertyValue('--header-sticky-height'),
          10
        );
        offset = Number.isFinite(cssVal) && cssVal > 0 ? cssVal : 60;
      }
      document.documentElement.style.setProperty('--gelato-header-offset', offset + 'px');
      return offset;
    }

    /**
     * Peel po pin ATC:
     *  peel=0 → chrome (title+ATC) pod hero
     *  peel=1 → hero pryč, title+ATC fixed pod shop headerem
     *  scroll zpět → stejná křivka; dy<0 → unpin
     */
    updateReleasedSectionMotion(stack, heroH, scrollY) {
      const pinY = this.sectionReleaseScrollY || 0;
      const dy = scrollY - pinY;
      const headerH = this.syncHeaderOffset();

      // dy < 0 = scroll nad bod nalepení → zpět do flow (ne dy<=0, ať se hned znovu nepinne)
      if (dy < 0) {
        this.unpinReleasedSection(stack);
        this.setMobileScrollMode('config');
        this.updateTopStickyChrome();
        return;
      }

      // startTop = title top při pin (≥ header); travel = jen hero pod headerem
      const startTop = Math.max(this.sectionReleaseHeroH || heroH || 1, headerH + 1);
      const travel = Math.max(startTop - headerH, 1);
      const peel = this.clamp01(dy / travel);

      // Jen hero odjede — title+ATC zůstanou v chrome pod headerem.
      const heroY = -peel * travel;
      stack.style.transform = 'translate3d(0, ' + heroY + 'px, 0)';
      stack.style.opacity = '1';
      stack.style.pointerEvents = peel > 0.85 ? 'none' : '';

      // chromeTop: peel=0 → startTop; peel=1 → headerH
      const chromeTop = Math.round(headerH + travel * (1 - peel));
      this.showStickyChrome(chromeTop);

      if (peel >= 1) {
        if (this.scrollMode !== 'detail') {
          this.setMobileScrollMode('detail');
        }
      } else if (this.scrollMode !== 'config') {
        this.setMobileScrollMode('config');
      }
    }

    /**
     * HeroMotion { expand, exit } — obousměrné se scrollem.
     * Po ATC attach = rychlá cesta (rAF + transform only).
     */
    updateMobileScrollChrome() {
      if (!this.isMobileGallery()) {
        this.setMobileScrollMode('desktop');
        this.updateTopStickyChrome();
        return;
      }

      const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (scrollY < 12) {
        const stackTop =
          this.stickyHeroStack ||
          document.querySelector('[data-gelato-sticky-hero]');
        this.unpinReleasedSection(stackTop);
        this.cachedTitleHeight = 0;
        this.setMobileScrollMode('top');
        this.ensureMobileBadgePlacement();
        this.updateTopStickyChrome();
        return;
      }

      const gallery = this.getGalleryRoot();
      const stack =
        this.stickyHeroStack ||
        (gallery && gallery.querySelector('[data-gelato-sticky-hero]'));
      if (!stack) {
        this.updateTopStickyChrome();
        return;
      }

      const heroH =
        this.heroPinnedHeight ||
        this.lockedMobileViewportHeight ||
        Math.round((window.innerHeight || 1) * 0.4);

      // Rychlá cesta: nalepená sekce jede nahoru — bez layout thrash.
      if (this.sectionScrollReleased && stack.classList.contains('gelato-poster-hero-fixed')) {
        this.updateReleasedSectionMotion(stack, heroH, scrollY);
        return;
      }

      const headerH = this.syncHeaderOffset();
      const isFixed = stack.classList.contains('gelato-poster-hero-fixed');
      const spacer = stack.parentNode
        ? stack.parentNode.querySelector('[data-gelato-hero-spacer]')
        : null;
      const travelH =
        Number(stack.dataset.gelatoFullH || 0) ||
        this.heroPinnedHeight ||
        heroH;
      const pinProbe = isFixed
        ? spacer
          ? spacer.getBoundingClientRect().top
          : 0
        : stack.getBoundingClientRect().top;

      // Sticky hero dokuje pod fixed headerem → threshold = headerH
      if (
        pinProbe <= headerH + 1 ||
        isFixed ||
        this.scrollMode === 'config' ||
        this.scrollMode === 'detail'
      ) {
        if (this.scrollMode !== 'config') {
          this.setMobileScrollMode('config');
        }
        const expandProgress = this.clamp01(
          isFixed && spacer
            ? -spacer.getBoundingClientRect().top / Math.max(travelH * 0.4, 1)
            : 0
        );
        this.updateHeroPinMotion(stack, expandProgress, 0);
        this.updateTopStickyChrome();
        return;
      }

      this.setMobileScrollMode('top');
      this.updateTopStickyChrome();
    }

    ensureHeroFixedSpacer(stack) {
      if (!stack || !stack.parentNode) {
        return null;
      }
      let spacer = stack.parentNode.querySelector('[data-gelato-hero-spacer]');
      if (!spacer) {
        spacer = document.createElement('div');
        spacer.className = 'gelato-poster-hero-spacer';
        spacer.setAttribute('data-gelato-hero-spacer', 'true');
        spacer.setAttribute('aria-hidden', 'true');
        stack.parentNode.insertBefore(spacer, stack);
      }
      return spacer;
    }

    applyFixedHero() {
      const stack =
        this.stickyHeroStack ||
        document.querySelector('[data-gelato-sticky-hero]');
      const gallery = this.getGalleryRoot();
      if (!stack || !gallery) {
        return;
      }

      this.ensureStickyHeroStack(
        this.getGallerySlider(),
        stack.querySelector('[data-gelato-poster-gallery-combo]')
      );
      const frame = stack.querySelector('[data-gelato-sticky-hero-frame]');
      const motion = stack.querySelector('[data-gelato-hero-motion]');
      const slider =
        (frame && frame.querySelector('[data-product-single-media-slider]')) ||
        this.getGallerySlider();

      const galleryRect = gallery.getBoundingClientRect();
      const fullW = Math.max(1, Math.round(window.innerWidth || 0));
      const padL = Math.max(0, Math.round(galleryRect.left));
      const padR = Math.max(0, Math.round(fullW - galleryRect.right));
      const contentW = Math.max(1, fullW - padL - padR);
      // Start scale=1 (= sticky vzhled). Expand roste nahoru → full bleed.
      // Starý scale0<1 při pinu zmenšil text najednou = skok.
      const scaleMax = Math.max(1, fullW / contentW);

      this.normalizeMobileGalleryAspect(slider);
      const padStr = this.lockedGalleryPaddingTop || '100%';
      const padPct = parseFloat(padStr);
      const ratio = Number.isFinite(padPct) && padPct > 0 ? padPct / 100 : 1;
      // Jen výška obrázku je zastropovaná — sticky/scale tokeny beze změny.
      const baseH = Math.max(
        120,
        Math.min(Math.round(contentW * ratio), this.getMobileHeroHeightCapPx())
      );
      this.lockedMobileViewportHeight = baseH;
      this.heroPinnedHeight = baseH;

      if (slider) {
        const viewport = slider.querySelector('.flickity-viewport');
        if (viewport) {
          viewport.style.height = baseH + 'px';
          viewport.style.minHeight = baseH + 'px';
          viewport.style.maxHeight = baseH + 'px';
        }
      }

      stack.dataset.gelatoPadL = String(padL);
      stack.dataset.gelatoPadR = String(padR);
      stack.dataset.gelatoContentW = String(contentW);
      stack.dataset.gelatoScale0 = '1';
      stack.dataset.gelatoScaleMax = String(scaleMax);
      stack.dataset.gelatoFullH = String(baseH);

      const headerH = this.syncHeaderOffset();
      stack.classList.add('gelato-poster-hero-fixed');
      stack.style.left = '0';
      stack.style.right = 'auto';
      stack.style.width = '100vw';
      stack.style.marginLeft = '0';
      stack.style.paddingLeft = '0';
      stack.style.paddingRight = '0';
      stack.style.top = headerH + 'px';
      stack.style.transform = 'translate3d(0, 0, 0)';
      stack.style.opacity = '1';

      // Motion = šířka gallery (jako sticky) — pin bez vizuální změny.
      if (motion) {
        motion.style.width = contentW + 'px';
        motion.style.maxWidth = '100%';
        motion.style.marginLeft = 'auto';
        motion.style.marginRight = 'auto';
        motion.style.height = '';
        motion.style.overflow = '';
      }

      const badge = stack.querySelector('[data-gelato-poster-gallery-combo]');
      if (badge && !badge.hidden) {
        badge.style.marginTop = '';
        badge.style.transform = '';
        this.cachedBadgeHeight = Math.round(badge.offsetHeight) || 0;
      }

      this.applyHeroMotionScale(stack, 1);

      const spacer = this.ensureHeroFixedSpacer(stack);
      if (spacer) {
        spacer.style.height =
          Math.round(baseH + (this.cachedBadgeHeight || 0)) + 'px';
      }
    }

    /**
     * Fotka + „Zvolená kombinace“ jako jeden celek.
     * scale 1 → scaleMax (roste), nikdy skok dolů při pinu.
     */
    applyHeroMotionScale(stack, scale) {
      if (!stack) {
        return;
      }
      const s = Number(scale);
      const motion = stack.querySelector('[data-gelato-hero-motion]');
      const frame = stack.querySelector('[data-gelato-sticky-hero-frame]');
      const badge = stack.querySelector('[data-gelato-poster-gallery-combo]');
      if (badge) {
        badge.style.marginTop = '';
        badge.style.transform = '';
        badge.style.transformOrigin = '';
        badge.style.willChange = '';
      }
      if (frame) {
        frame.style.transform = '';
        frame.style.transformOrigin = '';
        frame.style.willChange = '';
      }
      if (!motion) {
        return;
      }
      motion.style.height = '';
      motion.style.overflow = '';
      if (!Number.isFinite(s) || s <= 0) {
        motion.style.transform = '';
        motion.style.transformOrigin = '';
        motion.style.willChange = '';
        return;
      }
      motion.style.transformOrigin = '50% 0%';
      motion.style.willChange = 'transform';
      motion.style.transform = s === 1 ? 'none' : 'scale(' + s + ')';
    }

    updateHeroPinMotion(stack, expandProgress, exitProgress) {
      if (!stack) {
        return;
      }
      const expand = this.clamp01(expandProgress);
      const exit = this.clamp01(exitProgress);
      const scale0 = Number(stack.dataset.gelatoScale0 || 1);
      const scaleMax = Number(stack.dataset.gelatoScaleMax || 1);
      const baseH =
        Number(stack.dataset.gelatoFullH || 0) ||
        this.heroPinnedHeight ||
        0;
      const scale = scale0 + (scaleMax - scale0) * expand;
      const badgeH = this.cachedBadgeHeight || 0;

      this.applyHeroMotionScale(stack, scale);

      const spacer =
        stack.parentNode &&
        stack.parentNode.querySelector('[data-gelato-hero-spacer]');
      if (spacer && baseH > 0) {
        spacer.style.height = Math.round((baseH + badgeH) * scale) + 'px';
      }

      stack.style.transform = 'translate3d(0, ' + -exit * baseH * scale + 'px, 0)';
      stack.style.opacity = '1';
      stack.style.pointerEvents = exit > 0.85 ? 'none' : '';
    }

    resetHeroPinMotion(stack) {
      if (!stack) {
        return;
      }
      stack.style.transform = '';
      stack.style.opacity = '';
      stack.style.pointerEvents = '';
      const motion = stack.querySelector('[data-gelato-hero-motion]');
      if (motion) {
        motion.style.transform = '';
        motion.style.transformOrigin = '';
        motion.style.willChange = '';
        motion.style.height = '';
        motion.style.overflow = '';
        motion.style.width = '';
        motion.style.maxWidth = '';
        motion.style.marginLeft = '';
        motion.style.marginRight = '';
      }
      const frame = stack.querySelector('[data-gelato-sticky-hero-frame]');
      if (frame) {
        frame.style.transform = '';
        frame.style.transformOrigin = '';
        frame.style.willChange = '';
      }
      const badge = stack.querySelector('[data-gelato-poster-gallery-combo]');
      if (badge) {
        badge.style.transform = '';
        badge.style.transformOrigin = '';
        badge.style.willChange = '';
        badge.style.marginTop = '';
      }
    }

    clearFixedHero() {
      const stack =
        this.stickyHeroStack ||
        document.querySelector('[data-gelato-sticky-hero]');
      if (stack) {
        this.resetHeroPinMotion(stack);
        stack.classList.remove('gelato-poster-hero-fixed');
        stack.style.left = '';
        stack.style.right = '';
        stack.style.width = '';
        stack.style.marginLeft = '';
        stack.style.paddingLeft = '';
        stack.style.paddingRight = '';
        stack.style.top = '';
        delete stack.dataset.gelatoPadL;
        delete stack.dataset.gelatoPadR;
        delete stack.dataset.gelatoContentW;
        delete stack.dataset.gelatoScale0;
        delete stack.dataset.gelatoScaleMax;
        delete stack.dataset.gelatoFullH;
      }
      const slider = this.getGallerySlider();
      if (slider) {
        slider.classList.remove('gelato-poster-hero-fixed');
        slider.style.left = '';
        slider.style.width = '';
        slider.style.right = '';
        slider.style.top = '';
        slider.style.transform = '';
        // Po full-bleed zůstala výška fullW×aspect → bílá díra nad badge.
        if (this.isMobileGallery()) {
          this.syncMobileGalleryViewportHeight(slider);
        }
      }

      const spacer = document.querySelector('[data-gelato-hero-spacer]');
      if (spacer) {
        // Bez programmatic scrollTo — na iOS bije do momentum a „zasekne“ stránku.
        spacer.style.height = '0px';
      }
      this.heroPinnedHeight = null;
    }

    setMobileScrollMode(mode) {
      if (this.scrollMode === mode) {
        return;
      }

      this.scrollMode = mode;
      const html = document.documentElement;
      html.classList.remove(
        'gelato-poster-scroll--top',
        'gelato-poster-scroll--config',
        'gelato-poster-scroll--detail'
      );

      if (mode === 'desktop') {
        if (this.gallerySpacer) {
          this.gallerySpacer.style.height = '0px';
        }
        this.clearFixedHero();
        this.unwrapStickyHeroStack();
        this.clearTitleSticky();
        const slider = this.getGallerySlider();
        this.unlockMobileGalleryHeight(slider);
        this.destroyDesktopFlickity(slider);
        return;
      }

      if (mode === 'top' || mode === 'config' || mode === 'detail') {
        html.classList.add('gelato-poster-scroll--' + mode);
      }

      if (this.gallerySpacer) {
        this.gallerySpacer.style.height = '0px';
      }

      if (mode === 'config') {
        const stack =
          this.stickyHeroStack ||
          document.querySelector('[data-gelato-sticky-hero]');
        // Už fixed = nepřepisuj transform (trhání při detail↔config).
        if (!stack || !stack.classList.contains('gelato-poster-hero-fixed')) {
          this.applyFixedHero();
        }
      } else if (mode === 'top') {
        this.clearFixedHero();
      }
      // detail: fixed zůstává (exit=1), scroll nahoru ho vrátí přes updateReleasedSectionMotion
    }

    /**
     * Mobil UX A: title zůstane, shipping ikony / dlouhé info sbalí za „více“.
     */
    initMobileMetaCollapse() {
      if (!this.isMobileGallery()) {
        return;
      }
      const details = this.productScope.querySelector('.product-single__details');
      if (!details || details.querySelector('[data-gelato-meta-toggle]')) {
        return;
      }
      const titleBlock = details.querySelector('.product__title-and-price');
      if (!titleBlock) {
        return;
      }

      const designEl =
        details.querySelector('[data-design-nahledy-root], .design-nahledy') ||
        details.querySelector('[data-gelato-poster-configurator]') ||
        this.root;
      const designBlock =
        (designEl && designEl.closest && designEl.closest('.product__block')) || designEl;
      if (!designBlock || !designBlock.parentNode) {
        return;
      }

      const collapsible = [];
      let node = titleBlock.nextElementSibling;
      while (node && node !== designBlock) {
        if (
          node.querySelector &&
          (node.querySelector('[data-design-nahledy-root], .design-nahledy, [data-gelato-poster-configurator]') ||
            node.classList.contains('gelato-poster-configurator'))
        ) {
          break;
        }
        if (node.querySelector && node.querySelector('.product__icon__row')) {
          collapsible.push(node);
        }
        node = node.nextElementSibling;
      }
      if (collapsible.length === 0) {
        return;
      }

      const wrap = document.createElement('div');
      wrap.className = 'gelato-poster-meta-collapse';
      wrap.hidden = true;
      collapsible.forEach(function (el) {
        wrap.appendChild(el);
      });

      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'gelato-poster-meta-toggle';
      toggle.setAttribute('data-gelato-meta-toggle', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = 'více info';

      const toggleRow = document.createElement('div');
      toggleRow.className = 'gelato-poster-meta-toggle-row product__block';
      toggleRow.appendChild(toggle);

      // Pořadí: … cena → „více info“ → (sbalené info) → design
      designBlock.parentNode.insertBefore(toggleRow, designBlock);
      designBlock.parentNode.insertBefore(wrap, designBlock);

      toggle.addEventListener('click', function () {
        const open = wrap.hidden;
        wrap.hidden = !open;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.textContent = open ? 'méně' : 'více info';
      });
    }

    /**
     * Theme ProductForm.updateProductImage volá flkty.select(variant featured media)
     * a posune hlavní carousel + thumbs (asNavFor). U Gelato držíme fixních N fotek:
     * desktop = varianta do side (vpravo), mobil = varianta do hero (index 0).
     */
    installGallerySelectGuard(carousel) {
      const flickityApi = this.getFlickityApi();
      if (!flickityApi || !carousel) {
        return;
      }
      const flkty = flickityApi.data(carousel);
      if (!flkty || typeof flkty.select !== 'function' || flkty.__gelatoSelectGuarded) {
        return;
      }

      const self = this;
      const originalSelect = flkty.select.bind(flkty);
      flkty.select = function (index, isInstant, suppress) {
        if (self.allowGallerySelect) {
          return originalSelect(index, isInstant, suppress);
        }
        // Theme updateProductImage + asNavFor: držet index 0 po celý sync window.
        if (self.suppressThemeMediaSelect) {
          self.allowGallerySelect = true;
          try {
            return originalSelect(0, true, true);
          } finally {
            self.allowGallerySelect = false;
          }
        }
        return originalSelect(index, isInstant, suppress);
      };
      flkty.__gelatoSelectGuarded = true;

      if (flkty.options) {
        flkty.options.adaptiveHeight = false;
        flkty.options.wrapAround = false;
      }
    }

    selectGalleryIndex(carousel, index) {
      const flickityApi = this.getFlickityApi();
      if (!flickityApi || !carousel) {
        return;
      }
      const flkty = flickityApi.data(carousel);
      if (!flkty || typeof flkty.select !== 'function') {
        return;
      }
      this.installGallerySelectGuard(carousel);
      this.allowGallerySelect = true;
      try {
        flkty.select(index, false, true);
      } finally {
        this.allowGallerySelect = false;
      }
    }

    variantOption(variant, indexKey) {
      return variant[indexKey];
    }

    matchingVariants(filters) {
      const self = this;
      return this.product.variants.filter(function (variant) {
        if (filters.design && self.variantOption(variant, self.designIndex) !== filters.design) {
          return false;
        }
        if (filters.frame && self.variantOption(variant, self.frameIndex) !== filters.frame) {
          return false;
        }
        if (filters.sizeCode) {
          const code = sizeCodeFromOptionValue(self.variantOption(variant, self.sizeIndex));
          if (code !== filters.sizeCode) {
            return false;
          }
        }
        return true;
      });
    }

    resolveOrientationSizeValue(design, frame, sizeCode) {
      const matches = this.matchingVariants({ design: design, frame: frame, sizeCode: sizeCode });
      if (matches.length === 0) {
        return null;
      }
      if (matches.length === 1) {
        return this.variantOption(matches[0], this.sizeIndex);
      }

      const preferHorizontal = preferHorizontalDesign(design);
      const preferred = matches.find((variant) => {
        const orientation = orientationFromOptionValue(this.variantOption(variant, this.sizeIndex));
        return preferHorizontal ? orientation === 'Horizontal' : orientation === 'Vertical';
      });

      if (preferred) {
        return this.variantOption(preferred, this.sizeIndex);
      }

      throw new Error(
        'gelato-poster-configurator: nejednoznačná orientace pro ' +
          [design, frame, sizeCode].join(' / ')
      );
    }

    designButtons() {
      return this.productScope.querySelectorAll('[data-gelato-poster-design]');
    }

    updateAvailability() {
      const self = this;
      const design = this.designValue;
      const frame = this.frameValue;
      const sizeCode = this.sizeCode;

      this.designButtons().forEach(function (btn) {
        const value = btn.getAttribute('data-value');
        const available = self.matchingVariants({
          design: value,
          frame: frame || null,
          sizeCode: sizeCode || null,
        }).length > 0;
        btn.hidden = !available;
        btn.disabled = !available;
        if (!available && self.designValue === value) {
          self.designValue = null;
        }
      });

      this.root.querySelectorAll('[data-gelato-poster-frame]').forEach(function (btn) {
        const value = btn.getAttribute('data-value');
        const available = self.matchingVariants({
          design: design || null,
          frame: value,
          sizeCode: sizeCode || null,
        }).length > 0;
        btn.hidden = !available;
        btn.disabled = !available;
        if (!available && self.frameValue === value) {
          self.frameValue = null;
        }
      });

      this.root.querySelectorAll('[data-gelato-poster-size]').forEach(function (btn) {
        const code = btn.getAttribute('data-size-code');
        const available = self.matchingVariants({
          design: design || null,
          frame: frame || null,
          sizeCode: code,
        }).length > 0;
        btn.hidden = !available;
        btn.disabled = !available;
        if (!available && self.sizeCode === code) {
          self.sizeCode = null;
        }
      });
    }

    preserveScroll(callback) {
      const x = window.scrollX;
      const y = window.scrollY;
      const active = document.activeElement;
      callback.call(this);
      if (active && typeof active.blur === 'function' && active !== document.body) {
        active.blur();
      }
      const restore = function () {
        window.scrollTo(x, y);
      };
      restore();
      requestAnimationFrame(function () {
        restore();
        requestAnimationFrame(restore);
      });
    }

    isMobileGallery() {
      return !window.matchMedia('(min-width: 1024px)').matches;
    }

    /**
     * Max výška mobilního hero — square 100% šířky bere ~½ displeje a parametry skáčou.
     */
    getMobileHeroHeightCapPx() {
      const vh = window.innerHeight || 700;
      return Math.max(180, Math.min(Math.round(vh * 0.34), 260));
    }

    /**
     * Mobil: všechny slidů stejný aspect box — různý padding-top = skok při swipe/select.
     * Aspect se hned zastropuje (cap), ať hero nezabere půlku obrazovky.
     */
    normalizeMobileGalleryAspect(slider) {
      if (!slider || !this.isMobileGallery()) {
        return;
      }
      const heightEls = Array.from(
        slider.querySelectorAll('.product-single__media--image-height')
      );
      if (!heightEls.length) {
        return;
      }

      if (!this.lockedGalleryPaddingTop) {
        const featured =
          slider.querySelector(
            '.product-single__media-slide.gelato-poster-gallery__hero .product-single__media--image-height'
          ) || heightEls[0];
        const raw = (featured && featured.style.paddingTop) || '100%';
        const rawPct = parseFloat(raw);
        const ratio = Number.isFinite(rawPct) && rawPct > 0 ? rawPct / 100 : 1;
        const contentW = Math.max(
          1,
          Math.round(slider.clientWidth || window.innerWidth || 1)
        );
        const naturalH = contentW * ratio;
        const h = Math.min(naturalH, this.getMobileHeroHeightCapPx());
        this.lockedGalleryPaddingTop =
          ((h / contentW) * 100).toFixed(4) + '%';
      }

      const pad = this.lockedGalleryPaddingTop;
      heightEls.forEach(function (el) {
        el.style.paddingTop = pad;
      });
      document.documentElement.style.setProperty('--gelato-gallery-pad', pad);

      // Zoom / video wrappery se stejným inline paddingem
      Array.from(
        slider.querySelectorAll(
          '.product-single__media-slide [style*="padding-top"]'
        )
      ).forEach(function (el) {
        if (el.classList.contains('product-single__media--image-height')) {
          return;
        }
        if (
          el.classList.contains('product-single__media') ||
          el.hasAttribute('data-zoom-wrapper') ||
          el.classList.contains('lazy-image')
        ) {
          el.style.paddingTop = pad;
        }
      });
    }

    /**
     * Výška viewportu = aktuální šířka × aspect.
     * Při full-bleed expand šířka roste — musí se přepočítat, jinak overflow ořízne spodek.
     */
    syncMobileGalleryViewportHeight(slider) {
      if (!slider || !this.isMobileGallery()) {
        return;
      }
      this.normalizeMobileGalleryAspect(slider);
      const viewport = slider.querySelector('.flickity-viewport');
      if (!viewport) {
        return;
      }
      const padStr = this.lockedGalleryPaddingTop || '100%';
      const padPct = parseFloat(padStr);
      const ratio = Number.isFinite(padPct) && padPct > 0 ? padPct / 100 : 1;
      const width = Math.round(viewport.clientWidth || slider.clientWidth || 0);
      if (width < 80) {
        return;
      }
      const height = Math.max(
        120,
        Math.min(Math.round(width * ratio), this.getMobileHeroHeightCapPx())
      );
      viewport.style.height = height + 'px';
      viewport.style.minHeight = height + 'px';
      viewport.style.maxHeight = height + 'px';
      this.lockedMobileViewportHeight = height;

      const stack =
        this.stickyHeroStack ||
        document.querySelector('[data-gelato-sticky-hero]');
      if (stack && stack.classList.contains('gelato-poster-hero-fixed')) {
        const badgeH = this.cachedBadgeHeight || 0;
        const stackH =
          Math.round(stack.getBoundingClientRect().height) || height + badgeH;
        this.heroPinnedHeight = stackH;
        const spacer =
          stack.parentNode &&
          stack.parentNode.querySelector('[data-gelato-hero-spacer]');
        if (spacer) {
          spacer.style.height = stackH + 'px';
        }
      }
    }

    lockMobileGalleryHeight(slider) {
      this.syncMobileGalleryViewportHeight(slider);
    }

    unlockMobileGalleryHeight(slider) {
      this.lockedMobileViewportHeight = null;
      this.lockedGalleryPaddingTop = null;
      document.documentElement.style.removeProperty('--gelato-gallery-pad');
      if (!slider) {
        return;
      }
      const viewport = slider.querySelector('.flickity-viewport');
      if (!viewport) {
        return;
      }
      viewport.style.height = '';
      viewport.style.minHeight = '';
      viewport.style.maxHeight = '';
    }

    getFlickityApi() {
      if (typeof window.Flickity !== 'undefined' && window.Flickity.data) {
        return window.Flickity;
      }
      if (window.themeVendor && window.themeVendor.Flickity && window.themeVendor.Flickity.data) {
        return window.themeVendor.Flickity;
      }
      return null;
    }

    placeGallerySlide(slide, className, gridColumn, gridRow) {
      slide.classList.add(className);
      slide.style.gridColumn = gridColumn;
      slide.style.gridRow = String(gridRow);
    }

    clearCustomGalleryPlacement(slider) {
      const layoutClasses = [
        'gelato-poster-gallery__hero',
        'gelato-poster-gallery__side',
        'gelato-poster-gallery__grid-cell',
        'gelato-poster-gallery__grid-cell-wide',
      ];
      Array.from(slider.querySelectorAll('.product-single__media-slide')).forEach(function (slide) {
        layoutClasses.forEach(function (className) {
          slide.classList.remove(className);
        });
        slide.style.gridColumn = '';
        slide.style.gridRow = '';
      });
    }

    getGallerySlides(slider) {
      return Array.from(slider.querySelectorAll('.product-single__media-slide'));
    }

    getThumbsSlider() {
      return this.root.closest('[data-product]')?.querySelector('[data-product-single-media-thumbs]');
    }

    refreshGallery(slider) {
      if (!slider) {
        return;
      }

      // Desktop = CSS grid (max 6 viditelných). Flickity nesmí zůstat.
      if (!this.isMobileGallery()) {
        this.destroyDesktopFlickity(slider);
        return;
      }

      const flickityApi = this.getFlickityApi();
      if (!flickityApi) {
        return;
      }
      const flkty = flickityApi.data(slider);
      if (!flkty) {
        return;
      }

      this.installGallerySelectGuard(slider);
      // Nejdřív jednotný aspect, pak Flickity resize — jinak změří různě vysoké slidů.
      this.normalizeMobileGalleryAspect(slider);
      // Musí reloadCells — jinak Flickity dál drží všech 80 slidů i s display:none.
      if (typeof flkty.reloadCells === 'function') {
        flkty.reloadCells();
      }
      if (typeof flkty.resize === 'function') {
        flkty.resize();
      }
      this.lockedMobileViewportHeight = null;
      this.lockMobileGalleryHeight(slider);
      this.selectGalleryIndex(slider, 0);
    }

    refreshThumbs(thumbs) {
      if (!thumbs) {
        return;
      }
      if (!this.isMobileGallery()) {
        this.destroyDesktopFlickity(this.getGallerySlider());
        return;
      }
      const flickityApi = this.getFlickityApi();
      if (!flickityApi) {
        return;
      }
      const flkty = flickityApi.data(thumbs);
      if (!flkty) {
        return;
      }
      this.installGallerySelectGuard(thumbs);
      if (typeof flkty.reloadCells === 'function') {
        flkty.reloadCells();
      }
      if (typeof flkty.resize === 'function') {
        flkty.resize();
      }
      this.selectGalleryIndex(thumbs, 0);
    }

    applyDefaultGalleryVisibility(slider) {
      if (!slider) {
        return;
      }
      this.ensureProductFeaturedFirst(slider);
      this.rememberGalleryDefaultOrder(slider);
      this.clearCustomGalleryPlacement(slider);

      const slides = this.getGallerySlides(slider);
      const limit = this.defaultVisibleCount;
      const visibleIds = Object.create(null);

      slides.forEach(function (slide, index) {
        const mediaId = slide.getAttribute('data-id');
        if (index < limit) {
          slide.classList.remove('gelato-poster-gallery__deferred', 'media--hidden');
          slide.removeAttribute('hidden');
          if (mediaId) {
            visibleIds[mediaId] = true;
          }
        } else {
          slide.classList.add('gelato-poster-gallery__deferred');
          slide.classList.remove('media--hidden');
          slide.setAttribute('hidden', '');
        }
      });

      const thumbs = this.getThumbsSlider();
      if (thumbs) {
        this.ensureProductFeaturedThumbFirst(thumbs);
        Array.from(thumbs.querySelectorAll('.product-single__thumbnail')).forEach(function (thumb) {
          const mediaId = thumb.getAttribute('data-id');
          if (mediaId && visibleIds[mediaId]) {
            thumb.classList.remove('gelato-poster-gallery__deferred');
            thumb.removeAttribute('hidden');
          } else {
            thumb.classList.add('gelato-poster-gallery__deferred');
            thumb.setAttribute('hidden', '');
          }
        });
      }

      this.defaultGalleryApplied = true;
      if (!this.heroOriginalSnapshot) {
        const heroSlide = this.getHeroSlide(slider);
        if (heroSlide) {
          this.heroOriginalSnapshot = this.snapshotSlideImage(heroSlide);
        }
      }
      this.refreshGallery(slider);
      this.refreshThumbs(thumbs);
      this.lockMobileGalleryHeight(slider);
    }

    getProductFeaturedMediaId() {
      const group = this.root.closest('[data-product]')?.querySelector('[data-product-single-media-group]');
      if (!group) {
        return null;
      }
      const mediaId = group.getAttribute('data-product-featured-media-id');
      if (!mediaId) {
        throw new Error('gelato-poster-configurator: chybí data-product-featured-media-id na galerii');
      }
      return String(mediaId);
    }

    ensureProductFeaturedFirst(slider) {
      const featuredId = this.getProductFeaturedMediaId();
      const slides = this.getGallerySlides(slider);
      if (slides.length === 0) {
        throw new Error('gelato-poster-configurator: galerie nemá žádné slides');
      }
      const featuredSlide = slides.find(function (slide) {
        return slide.getAttribute('data-id') === featuredId;
      });
      if (!featuredSlide) {
        throw new Error('gelato-poster-configurator: v galerii chybí product.featured_media id ' + featuredId);
      }
      if (slides[0] !== featuredSlide) {
        slider.insertBefore(featuredSlide, slides[0]);
      }
    }

    ensureProductFeaturedThumbFirst(thumbs) {
      if (!thumbs) {
        return;
      }
      const featuredId = this.getProductFeaturedMediaId();
      const thumbsList = Array.from(thumbs.querySelectorAll('.product-single__thumbnail'));
      if (thumbsList.length === 0) {
        return;
      }
      const featuredThumb = thumbsList.find(function (thumb) {
        return thumb.getAttribute('data-id') === featuredId;
      });
      if (!featuredThumb) {
        throw new Error('gelato-poster-configurator: v thumbs chybí product.featured_media id ' + featuredId);
      }
      if (thumbsList[0] !== featuredThumb) {
        thumbs.insertBefore(featuredThumb, thumbsList[0]);
      }
    }

    syncGalleryLayout() {
      const slider = this.getGallerySlider();
      if (!slider) {
        return;
      }

      const isMobile = this.isMobileGallery();
      const breakpointChanged =
        this.galleryWasMobile !== null && this.galleryWasMobile !== isMobile;
      this.galleryWasMobile = isMobile;

      if (!isMobile) {
        this.unwrapStickyHeroStack();
        this.unlockMobileGalleryHeight(slider);
        this.destroyDesktopFlickity(slider);
      } else {
        this.ensureMobileBadgePlacement();
        // Width resize: přeměř výšku. Stejný breakpoint bez změny šířky: drž lock.
        if (breakpointChanged) {
          this.lockedMobileViewportHeight = null;
          this.lockedGalleryPaddingTop = null;
        }
      }

      // Resize ve stejném breakpointu: nepřestavuj DOM (blikání).
      if (this.defaultGalleryApplied && !breakpointChanged) {
        this.lockMobileGalleryHeight(slider);
        return;
      }

      this.applyDefaultGalleryVisibility(slider);
      this.prefetchGalleryImages(slider);
      if (this.lastPromotedVariant) {
        this.currentSideMediaId = null;
        this.promoteVariantSide(this.lastPromotedVariant);
      }
    }

    getGallerySlider() {
      return this.root.closest('[data-product]')?.querySelector('[data-product-single-media-slider]');
    }

    rememberGalleryDefaultOrder(slider) {
      if (this.galleryDefaultOrder) {
        return;
      }
      this.galleryDefaultOrder = this.getGallerySlides(slider).map(function (slide) {
        return slide.getAttribute('data-id');
      });
    }

    getHeroSlide(slider) {
      const slides = this.getGallerySlides(slider);
      return slides.find(function (slide) {
        return !slide.classList.contains('gelato-poster-gallery__deferred');
      }) || slides[0] || null;
    }

    snapshotSlideImage(slide) {
      const mediaId = slide && slide.getAttribute('data-id');
      if (mediaId && this.snapshotCache[mediaId]) {
        return this.snapshotCache[mediaId];
      }

      const img = slide && slide.querySelector('img');
      if (!img) {
        return null;
      }
      const heightEl = slide.querySelector('.product-single__media--image-height');
      const zoom = slide.querySelector('[data-zoom-wrapper]');
      const snapshot = {
        src: img.getAttribute('src') || '',
        srcset: img.getAttribute('srcset') || '',
        sizes: img.getAttribute('sizes') || '',
        alt: img.getAttribute('alt') || '',
        width: img.getAttribute('width'),
        height: img.getAttribute('height'),
        paddingTop: heightEl ? heightEl.style.paddingTop : '',
        zoomHref: zoom ? zoom.getAttribute('href') : null,
      };

      if (mediaId && snapshot.src) {
        this.snapshotCache[mediaId] = snapshot;
      }
      return snapshot;
    }

    applyImageSnapshot(slide, snapshot) {
      if (!slide || !snapshot) {
        return;
      }
      const img = slide.querySelector('img');
      if (!img) {
        throw new Error('gelato-poster-configurator: hero slide nemá img');
      }

      const nextSrc = snapshot.src || '';
      const nextSrcset = snapshot.srcset || '';
      if (
        img.getAttribute('src') === nextSrc &&
        (img.getAttribute('srcset') || '') === nextSrcset
      ) {
        const figureSame = img.closest('.lazy-image');
        if (figureSame) {
          figureSame.classList.remove('is-loading');
        }
        img.classList.remove('is-loading');
        img.style.opacity = '1';
        return;
      }

      if (nextSrc) {
        img.setAttribute('src', nextSrc);
      }
      if (nextSrcset) {
        img.setAttribute('srcset', nextSrcset);
      } else {
        img.removeAttribute('srcset');
      }
      if (snapshot.sizes) {
        img.setAttribute('sizes', snapshot.sizes);
      }
      if (snapshot.alt != null) {
        img.setAttribute('alt', snapshot.alt);
      }
      if (snapshot.width) {
        img.setAttribute('width', snapshot.width);
      }
      if (snapshot.height) {
        img.setAttribute('height', snapshot.height);
      }

      // Padding-top NEměnit — jednotný aspect box (jinak skok výšky galerie).
      const heightEl = slide.querySelector('.product-single__media--image-height');
      if (heightEl && this.lockedGalleryPaddingTop) {
        heightEl.style.paddingTop = this.lockedGalleryPaddingTop;
      }

      const zoom = slide.querySelector('[data-zoom-wrapper]');
      if (zoom && snapshot.zoomHref) {
        zoom.setAttribute('href', snapshot.zoomHref);
      }

      const figure = img.closest('.lazy-image');
      if (figure) {
        figure.classList.remove('is-loading');
      }
      img.classList.remove('is-loading');
      img.loading = 'eager';
      img.style.opacity = '1';
    }

    revealAllGallerySlides(slider) {
      this.applyDefaultGalleryVisibility(slider);
    }

    prefetchUrl(url) {
      if (!url || this.prefetchedUrls[url]) {
        return;
      }
      this.prefetchedUrls[url] = true;
      const pre = new Image();
      pre.decoding = 'async';
      pre.src = url;
    }

    prefetchGalleryImages(slider) {
      if (!slider) {
        return;
      }
      const self = this;
      slider.querySelectorAll('.product-single__media-slide img').forEach(function (img) {
        img.loading = 'eager';
        self.prefetchUrl(img.currentSrc || img.getAttribute('src') || '');
        const srcset = img.getAttribute('srcset');
        if (srcset) {
          srcset.split(',').forEach(function (part) {
            const candidate = part.trim().split(/\s+/)[0];
            self.prefetchUrl(candidate);
          });
        }
        self.snapshotSlideImage(img.closest('.product-single__media-slide'));
      });
    }

    variantFeaturedMediaId(variant) {
      if (!variant) {
        return null;
      }
      const mapped = this.variantMediaMap[String(variant.id)];
      if (mapped != null) {
        return String(mapped);
      }
      if (variant.featured_media && variant.featured_media.id != null) {
        return String(variant.featured_media.id);
      }
      if (variant.featured_image && variant.featured_image.id != null) {
        return String(variant.featured_image.id);
      }
      return null;
    }

    promoteVariantSide(variant) {
      const slider = this.getGallerySlider();
      if (!slider) {
        throw new Error('gelato-poster-configurator: chybí product gallery slider');
      }

      this.rememberGalleryDefaultOrder(slider);
      if (!this.defaultGalleryApplied) {
        this.applyDefaultGalleryVisibility(slider);
      }

      const mediaId = this.variantFeaturedMediaId(variant);
      if (!mediaId) {
        throw new Error('gelato-poster-configurator: varianta ' + variant.id + ' nemá featured image');
      }

      this.lastPromotedVariant = variant;

      if (this.currentSideMediaId === mediaId) {
        return;
      }

      const featuredId = this.getProductFeaturedMediaId();
      this.ensureProductFeaturedFirst(slider);

      const heroSlide = this.getHeroSlide(slider);
      if (!heroSlide) {
        throw new Error('gelato-poster-configurator: chybí hero slide');
      }

      if (!this.heroOriginalSnapshot) {
        this.heroOriginalSnapshot = this.snapshotSlideImage(heroSlide);
      }

      // Mobil: vybraná varianta do hero. Desktop: hero beze změny, varianta do side.
      if (this.isMobileGallery()) {
        this.restoreSideImage(slider);

        if (mediaId === featuredId) {
          this.restoreHeroImage(slider);
          this.currentSideMediaId = mediaId;
          this.lockMobileGalleryHeight(slider);
          return;
        }

        this.swapSlideToVariantMedia(slider, heroSlide, this.heroOriginalSnapshot, mediaId, variant.id);
        return;
      }

      this.restoreHeroImage(slider);

      const sideSlide = this.getOrInitSideSlide(slider, heroSlide);
      if (!sideSlide) {
        throw new Error('gelato-poster-configurator: chybí side slide pro variantu');
      }

      if (!this.sideOriginalSnapshot) {
        this.sideOriginalSnapshot = this.snapshotSlideImage(sideSlide);
      }

      if (mediaId === featuredId) {
        this.restoreSideImage(slider);
        this.currentSideMediaId = mediaId;
        return;
      }

      this.swapSlideToVariantMedia(slider, sideSlide, this.sideOriginalSnapshot, mediaId, variant.id);
    }

    swapSlideToVariantMedia(slider, targetSlide, boxSnapshot, mediaId, variantId) {
      const sourceSlide = slider.querySelector('.product-single__media-slide[data-id="' + mediaId + '"]');
      if (!sourceSlide) {
        throw new Error(
          'gelato-poster-configurator: v galerii chybí media id ' + mediaId + ' pro variantu ' + variantId
        );
      }

      const sourceImg = sourceSlide.querySelector('img');
      const sourceSnapshot = this.snapshotSlideImage(sourceSlide);
      if (!sourceSnapshot || !sourceSnapshot.src) {
        throw new Error('gelato-poster-configurator: source slide nemá src pro variantu ' + variantId);
      }

      // Stabilní box cílového slotu — žádný DOM move / Flickity reload (to bliká).
      const stableSnapshot = Object.assign({}, sourceSnapshot, {
        paddingTop: (boxSnapshot && boxSnapshot.paddingTop) || sourceSnapshot.paddingTop,
        width: (boxSnapshot && boxSnapshot.width) || sourceSnapshot.width,
        height: (boxSnapshot && boxSnapshot.height) || sourceSnapshot.height,
      });

      this.sideSwapToken += 1;
      const token = this.sideSwapToken;
      const self = this;

      const apply = function () {
        if (token !== self.sideSwapToken) {
          return;
        }
        self.applyImageSnapshot(targetSlide, stableSnapshot);
        self.currentSideMediaId = mediaId;
        self.lockMobileGalleryHeight(slider);
      };

      if (sourceImg && sourceImg.complete && sourceImg.naturalWidth > 0) {
        apply();
        return;
      }

      const preloadUrl = (sourceImg && sourceImg.currentSrc) || sourceSnapshot.src;
      this.prefetchUrl(preloadUrl);
      const preload = new Image();
      preload.decoding = 'async';
      preload.onerror = function () {
        if (token !== self.sideSwapToken) {
          return;
        }
        self.showError('Nepodařilo se načíst obrázek varianty: ' + preloadUrl);
      };
      preload.onload = function () {
        if (typeof preload.decode === 'function') {
          preload.decode().then(apply).catch(apply);
        } else {
          apply();
        }
      };
      preload.src = preloadUrl;
      if (preload.complete && preload.naturalWidth > 0) {
        apply();
      }
    }

    getOrInitSideSlide(slider, heroSlide) {
      const existingSide = slider.querySelector('.product-single__media-slide.gelato-poster-gallery__side');
      if (existingSide) {
        return existingSide;
      }

      const slides = this.getGallerySlides(slider);
      const sideSlide = slides.find(function (slide) {
        return (
          slide !== heroSlide &&
          !slide.classList.contains('gelato-poster-gallery__deferred')
        );
      });
      if (!sideSlide) {
        return null;
      }

      this.placeGallerySlide(heroSlide, 'gelato-poster-gallery__hero', '1', 1);
      this.placeGallerySlide(sideSlide, 'gelato-poster-gallery__side', '2', 1);
      return sideSlide;
    }

    restoreSideImage(slider) {
      this.sideSwapToken += 1;
      this.currentSideMediaId = null;
      if (!this.sideOriginalSnapshot) {
        return;
      }
      const sideSlide =
        (slider && slider.querySelector('.product-single__media-slide.gelato-poster-gallery__side')) ||
        null;
      if (!sideSlide) {
        return;
      }
      this.applyImageSnapshot(sideSlide, this.sideOriginalSnapshot);
      this.lockMobileGalleryHeight(slider);
    }

    restoreHeroImage(slider) {
      if (!this.heroOriginalSnapshot) {
        return;
      }
      const heroSlide = this.getHeroSlide(slider);
      if (!heroSlide) {
        return;
      }
      this.applyImageSnapshot(heroSlide, this.heroOriginalSnapshot);
      this.lockMobileGalleryHeight(slider);
    }

    setVariantSelected(active) {
      document.documentElement.classList.toggle('gelato-poster-configurator--variant-selected', active);
      this.root.closest('[data-product]')?.classList.toggle('gelato-poster-configurator--variant-selected', active);
    }

    initProductGalleryGrid() {
      this.syncGalleryLayout();
    }

    bindUi() {
      const self = this;

      this.root.querySelectorAll('[data-gelato-poster-size]').forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          btn.blur();
          self.preserveScroll(function () {
            self.sizeCode = btn.getAttribute('data-size-code');
            self.updateAvailability();
            self.syncFromSelections();
          });
        });
      });

      this.root.querySelectorAll('[data-gelato-poster-frame]').forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          btn.blur();
          self.preserveScroll(function () {
            self.frameValue = btn.getAttribute('data-value');
            self.updateAvailability();
            self.syncFromSelections();
          });
        });
      });

      this.designButtons().forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          btn.blur();
          self.preserveScroll(function () {
            self.designValue = btn.getAttribute('data-value');
            self.applyDefaultFrameAndSize();
            self.updateAvailability();
            self.syncFromSelections();
          });
        });
      });

      if (this.atcButton) {
        this.ensureAtcNeedsSelectionGuard();
        this.atcButton.addEventListener('click', function (event) {
          if (self.isComplete()) {
            return;
          }
          event.preventDefault();
          event.stopPropagation();
          self.clearError();
          self.applyNeedsSelectionAtc();
          self.scrollToDesignSelection();
          // Theme ProductForm po click znovu disabled — hned i po scrollu.
          self.applyNeedsSelectionAtc();
        });
      }

      this.form.addEventListener('submit', function (event) {
        if (!self.isComplete()) {
          event.preventDefault();
          self.scrollToDesignSelection();
          self.showError(self.config.promptCompleteSelection);
          self.applyNeedsSelectionAtc();
        }
      });
    }

    isComplete() {
      return !!(this.sizeCode && this.frameValue && this.designValue);
    }

    applyDefaultFrameAndSize() {
      this.updateAvailability();

      if (!this.sizeCode) {
        const firstSizeBtn = this.root.querySelector('[data-gelato-poster-size]:not([hidden])');
        if (!firstSizeBtn) {
          throw new Error('gelato-poster-configurator: chybí dostupná velikost pro vybraný design');
        }
        this.sizeCode = firstSizeBtn.getAttribute('data-size-code');
      }

      if (!this.frameValue) {
        const firstFrameBtn = this.root.querySelector('[data-gelato-poster-frame]:not([hidden])');
        if (!firstFrameBtn) {
          throw new Error('gelato-poster-configurator: chybí dostupný rám pro vybraný design');
        }
        this.frameValue = firstFrameBtn.getAttribute('data-value');
      }
    }

    initEmptyState() {
      this.setActiveButtons();
      this.syncHiddenInputs(false);
      this.setVariantSelected(false);
      this.showProductGallery();
      this.clearPreview();
      this.disableAddToCart();
      this.updatePartialLabel();
      this.updateProductPriceDisplay(null);
      this.clearError();
      this.syncInventoryCountdown();
      window.setTimeout(() => {
        this.setAddToCartLabel('select');
        this.updateProductPriceDisplay(null);
        this.syncInventoryCountdown();
      }, 0);
    }

    setActiveButtons() {
      const sizeCode = this.sizeCode;
      const frameValue = this.frameValue;
      const designValue = this.designValue;

      this.root.querySelectorAll('[data-gelato-poster-size]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-size-code') === sizeCode);
      });

      this.root.querySelectorAll('[data-gelato-poster-frame]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-value') === frameValue);
      });

      this.designButtons().forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-value') === designValue);
      });
    }

    syncHiddenInputs(dispatchChange) {
      const inputs = this.optionInputs;
      inputs.forEach(function (input) {
        const index = input.getAttribute('data-index');
        const value = this.selections[index] || '';
        input.value = value;
      }, this);

      if (!dispatchChange || inputs.length === 0) {
        return;
      }

      // Theme onOptionChange → updateHistoryState → Clarity/Wishlist wrap history → GTM Ads.
      // Během sync history ztlumíme; URL nastavíme přes History.prototype (mimo Clarity).
      // updateProductImage zároveň posune Flickity na featured media varianty — na mobilu
      // to hýbe pásem thumbs; potlačíme a držíme index 0 (hero swap).
      const slider = this.getGallerySlider();
      const thumbs = this.getThumbsSlider();
      this.installGallerySelectGuard(slider);
      this.installGallerySelectGuard(thumbs);

      const historyApi = window.history;
      const prevReplace = historyApi.replaceState;
      const prevPush = historyApi.pushState;
      historyApi.replaceState = function () {};
      historyApi.pushState = function () {};

      this.suppressThemeMediaSelect = true;
      try {
        inputs[inputs.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
      } finally {
        this.suppressThemeMediaSelect = false;
        historyApi.replaceState = prevReplace;
        historyApi.pushState = prevPush;
      }

      if (this.isMobileGallery()) {
        this.selectGalleryIndex(slider, 0);
        this.selectGalleryIndex(thumbs, 0);
        this.lockMobileGalleryHeight(slider);
      }

      const variantId = this.variantInput && this.variantInput.value;
      if (variantId && /\/products\//.test(window.location.pathname)) {
        const url = new URL(window.location.href);
        if (url.searchParams.get('variant') !== String(variantId)) {
          url.searchParams.set('variant', String(variantId));
          History.prototype.replaceState.call(
            historyApi,
            { path: url.toString() },
            '',
            url.toString()
          );
        }
      }
    }

    showProductGallery() {
      document.documentElement.classList.remove('gelato-poster-configurator--preview-active');
      this.root.closest('[data-product]')?.classList.remove('gelato-poster-configurator--preview-active');
      this.currentSideMediaId = null;
      this.lastPromotedVariant = null;
      const slider = this.getGallerySlider();
      if (slider) {
        this.restoreSideImage(slider);
        this.restoreHeroImage(slider);
        this.applyDefaultGalleryVisibility(slider);
      }
    }

    clearPreview() {
      if (this.previewHost) {
        this.previewHost.innerHTML = '';
        this.previewHost.style.display = 'none';
      }
    }

    disableAddToCart() {
      if (this.variantInput) {
        this.variantInput.value = '';
        this.variantInput.disabled = true;
      }
      this.lastEnabledVariant = null;
      this.setAddToCartLabel('select');
      this.applyNeedsSelectionAtc();
    }

    /**
     * „Vyberte variantu“ = aktivní CTA (scroll na design), ne šedý disabled.
     * Theme ProductForm po change/click znovu nastaví disabled — guard + timeout.
     * Mutace přes #writeNeedsSelectionAtcAttrs (flag) — jinak MutationObserver zacyklí
     * (setAttribute aria-disabled i při stejné hodnotě → freeze stránky při init).
     */
    applyNeedsSelectionAtc() {
      if (!this.atcButton || this.isComplete()) {
        return;
      }
      this.ensureAtcNeedsSelectionGuard();
      this.writeNeedsSelectionAtcAttrs();
      this.syncStickyAtcBar();
      this.reassertProductPriceDisplay();
      const reassert = () => {
        if (!this.atcButton || this.isComplete()) {
          return;
        }
        this.writeNeedsSelectionAtcAttrs();
        this.syncStickyAtcBar();
        this.reassertProductPriceDisplay();
      };
      requestAnimationFrame(reassert);
      window.setTimeout(reassert, 0);
      window.setTimeout(reassert, 50);
      window.setTimeout(reassert, 200);
      window.setTimeout(reassert, 500);
    }

    /**
     * Zápis ATC attrs jen když se hodnota mění + pod reentrancy flagem
     * (MutationObserver nesmí znovu mutovat při vlastní změně).
     */
    writeNeedsSelectionAtcAttrs() {
      const btn = this.atcButton;
      if (!btn) {
        return;
      }
      this.atcNeedsSelectionWriting = true;
      try {
        if (btn.disabled || btn.hasAttribute('disabled')) {
          btn.disabled = false;
          btn.removeAttribute('disabled');
        }
        if (btn.classList.contains('disabled')) {
          btn.classList.remove('disabled');
        }
        if (btn.getAttribute('aria-disabled') !== 'true') {
          btn.setAttribute('aria-disabled', 'true');
        }
        if (!btn.hasAttribute('data-gelato-atc-needs-selection')) {
          btn.setAttribute('data-gelato-atc-needs-selection', 'true');
        }
        if (!btn.classList.contains('gelato-poster-atc--needs-selection')) {
          btn.classList.add('gelato-poster-atc--needs-selection');
        }
      } finally {
        this.atcNeedsSelectionWriting = false;
      }
    }

    ensureAtcNeedsSelectionGuard() {
      if (!this.atcButton || this.atcNeedsSelectionObserver) {
        return;
      }
      const self = this;
      this.atcNeedsSelectionWriting = false;
      this.atcNeedsSelectionObserver = new MutationObserver(function () {
        if (self.atcNeedsSelectionWriting || self.isComplete() || !self.atcButton) {
          return;
        }
        self.writeNeedsSelectionAtcAttrs();
      });
      this.atcNeedsSelectionObserver.observe(this.atcButton, {
        attributes: true,
        attributeFilter: ['disabled', 'class', 'data-gelato-atc-needs-selection', 'aria-disabled'],
      });
    }

    enableAddToCart(variant) {
      if (!this.variantInput) {
        throw new Error('gelato-poster-configurator: chybí input name="id"');
      }
      // Hodnotu id nastaví i ProductForm po option change — tady jen pojistka + enable.
      // Druhý change na id nespouštíme (theme na něj neposlouchá a zbytečně by spouštěl trackery).
      this.variantInput.value = variant.id;
      this.variantInput.disabled = false;
      this.lastEnabledVariant = variant;

      if (this.atcButton) {
        this.atcButton.removeAttribute('aria-disabled');
        this.atcButton.removeAttribute('data-gelato-atc-needs-selection');
        this.atcButton.classList.remove('gelato-poster-atc--needs-selection');
        this.atcButton.disabled = !variant.available;
      }

      this.setAddToCartLabel(variant.available ? 'add' : 'sold_out', variant);
    }

    getDesignScrollTarget() {
      const firstDesign = this.designButtons()[0];
      if (firstDesign) {
        return firstDesign.closest('.design-nahledy') || firstDesign;
      }
      return (
        this.productScope.querySelector('.design-nahledy') ||
        this.productScope.querySelector('[data-design-nahledy-root]')
      );
    }

    /**
     * Po scrollu k Designu zůstane sticky hero + title — musí se započítat,
     * jinak Design skončí pod hero a ve viewportu je až množství/ATC.
     */
    getDesignScrollOffset() {
      const headerH = this.syncHeaderOffset();
      if (this.stickyChrome && !this.stickyChrome.hidden) {
        return Math.max(
          headerH,
          Math.round(this.stickyChrome.getBoundingClientRect().bottom)
        );
      }

      let offset = headerH;
      const stack =
        this.stickyHeroStack ||
        document.querySelector('[data-gelato-sticky-hero]');
      if (stack && this.isMobileGallery()) {
        const motion = stack.querySelector('[data-gelato-hero-motion]');
        const live = (motion || stack).getBoundingClientRect();
        if (live.bottom > headerH + 8 && live.top < window.innerHeight) {
          // Hero právě ve viewportu (fixed/sticky) — ber aktuální spodek.
          offset = Math.max(offset, Math.round(live.bottom));
        } else {
          // Scroll zespodu: hero se znovu připne — rezervuj typickou pinned výšku.
          const baseH =
            Number(stack.dataset.gelatoFullH || 0) ||
            this.heroPinnedHeight ||
            this.lockedMobileViewportHeight ||
            0;
          const badgeH = this.cachedBadgeHeight || 0;
          if (baseH > 0) {
            offset += Math.round(baseH + badgeH);
          }
        }
      }

      const title = this.getProductTitleBlock();
      if (title && this.isMobileGallery()) {
        const titleH = Math.round(title.getBoundingClientRect().height) || 0;
        if (title.classList.contains('gelato-poster-title--sticky') || titleH) {
          const titleBottom = Math.round(title.getBoundingClientRect().bottom);
          if (titleBottom > offset && titleBottom < window.innerHeight) {
            offset = titleBottom;
          } else {
            offset += titleH;
          }
        }
      }
      return offset;
    }

    /**
     * ATC „Vyberte variantu“ → Design hned pod sticky hero + title (ne pod hero pryč).
     */
    scrollToDesignSelection() {
      const target = this.getDesignScrollTarget();
      if (!target) {
        throw new Error('gelato-poster-configurator: chybí design náhledy pro scroll z ATC');
      }
      const offset = this.getDesignScrollOffset();
      const y =
        target.getBoundingClientRect().top +
        (window.pageYOffset || document.documentElement.scrollTop || 0) -
        offset -
        8;
      window.scrollTo({ top: Math.max(0, Math.round(y)), behavior: 'smooth' });

      // Po smooth scroll hero/title můžou změnit výšku — doladit na Design.
      window.setTimeout(() => {
        const t = this.getDesignScrollTarget();
        if (!t) {
          return;
        }
        const fix =
          t.getBoundingClientRect().top -
          this.getDesignScrollOffset() -
          8;
        if (Math.abs(fix) > 12) {
          window.scrollBy({ top: Math.round(fix), behavior: 'smooth' });
        }
      }, 400);
    }

    formatMoneyAmount(price) {
      if (typeof price !== 'number') {
        throw new Error('gelato-poster-configurator: price musí být number');
      }
      if (price === 0) {
        return this.config.freeLabel || 'Zdarma';
      }
      const moneyFormat =
        this.config.currencyCodeEnable && window.theme && window.theme.moneyWithCurrencyFormat
          ? window.theme.moneyWithCurrencyFormat
          : window.theme && window.theme.moneyFormat;
      if (!moneyFormat) {
        throw new Error('gelato-poster-configurator: theme.moneyFormat chybí');
      }
      const currency = window.themeVendor && window.themeVendor.themeCurrency;
      if (!currency || typeof currency.formatMoney !== 'function') {
        throw new Error('gelato-poster-configurator: themeCurrency.formatMoney chybí');
      }
      return currency.formatMoney(price, moneyFormat);
    }

    formatVariantPrice(variant) {
      const price = variant && typeof variant.price === 'number' ? variant.price : null;
      if (price === null) {
        throw new Error('gelato-poster-configurator: variant.price chybí');
      }
      return this.formatMoneyAmount(price);
    }

    getMinVariantPriceCents() {
      let min = null;
      (this.product.variants || []).forEach(function (variant) {
        if (typeof variant.price !== 'number') {
          return;
        }
        if (min === null || variant.price < min) {
          min = variant.price;
        }
      });
      if (min === null) {
        throw new Error('gelato-poster-configurator: produkt nemá variant.price');
      }
      return min;
    }

    getProductPriceWrappers() {
      const scope = this.productScope || this.root;
      return Array.from(scope.querySelectorAll('[data-price-wrapper]')).filter(function (el) {
        return !el.hasAttribute('data-atc-button');
      });
    }

    /**
     * Theme updateProductPrices při !variant udělá formatMoney('') → „0,00 Kč“.
     * Gelato drží „Od <min>“ / konkrétní cenu — po theme eventu i MutationObserver.
     */
    bindThemePriceGuard() {
      if (this.themePriceGuardBound) {
        return;
      }
      this.themePriceGuardBound = true;
      this.onThemeVariantChange = () => {
        this.reassertProductPriceDisplay();
      };
      document.addEventListener('theme:variant:change', this.onThemeVariantChange);

      const wrappers = this.getProductPriceWrappers();
      if (!wrappers.length || typeof MutationObserver === 'undefined') {
        return;
      }
      const self = this;
      this.priceDisplayObserver = new MutationObserver(function () {
        if (self.priceDisplayWriting) {
          return;
        }
        self.reassertProductPriceDisplay();
      });
      wrappers.forEach(function (wrap) {
        self.priceDisplayObserver.observe(wrap, {
          subtree: true,
          childList: true,
          characterData: true,
        });
      });
    }

    reassertProductPriceDisplay() {
      if (this.isComplete() && this.lastEnabledVariant) {
        this.updateProductPriceDisplay(this.lastEnabledVariant);
      } else {
        this.updateProductPriceDisplay(null);
      }
    }

    /**
     * Bez výběru: „Od <min>“. Po kompletní variantě: konkrétní cena.
     * Theme při !variant přidá product__price--hidden — u Gelato cenu držíme viditelnou.
     */
    updateProductPriceDisplay(variant) {
      const wrappers = this.getProductPriceWrappers();
      if (!wrappers.length) {
        return;
      }
      const prefix =
        this.config.fromPricePrefix != null ? String(this.config.fromPricePrefix) : 'Od ';
      const self = this;
      this.priceDisplayWriting = true;
      try {
        wrappers.forEach(function (wrap) {
          wrap.classList.remove('product__price--hidden');
          const priceEl = wrap.querySelector('[data-product-price]');
          if (!priceEl) {
            return;
          }
          const compareEl = wrap.querySelector('[data-compare-price]');
          const badgeEl = wrap.querySelector('.product-discount-badge');

          if (variant) {
            const next = self.formatVariantPrice(variant);
            if (priceEl.textContent !== next) {
              priceEl.textContent = next;
            }
            if (
              typeof variant.compare_at_price === 'number' &&
              variant.compare_at_price > variant.price
            ) {
              priceEl.classList.add('product__price--sale');
              if (compareEl) {
                const cmp = self.formatMoneyAmount(variant.compare_at_price);
                if (compareEl.textContent !== cmp) {
                  compareEl.textContent = cmp;
                }
                compareEl.classList.remove('hidden');
                compareEl.style.display = '';
              }
            } else {
              priceEl.classList.remove('product__price--sale');
              if (compareEl) {
                compareEl.textContent = '';
                compareEl.classList.add('hidden');
                compareEl.style.display = 'none';
              }
              if (badgeEl) {
                badgeEl.style.display = 'none';
              }
            }
            return;
          }

          const fromText = prefix + self.formatMoneyAmount(self.getMinVariantPriceCents());
          if (priceEl.textContent !== fromText) {
            priceEl.textContent = fromText;
          }
          priceEl.classList.remove('product__price--sale');
          if (compareEl) {
            compareEl.textContent = '';
            compareEl.classList.add('hidden');
            compareEl.style.display = 'none';
          }
          if (badgeEl) {
            badgeEl.style.display = 'none';
          }
        });
      } finally {
        this.priceDisplayWriting = false;
      }
    }

    setAddToCartLabel(mode, variant) {
      if (!this.atcTextEl) {
        return;
      }

      if (mode === 'add') {
        if (this.config.showPriceInButton) {
          if (!variant) {
            throw new Error('gelato-poster-configurator: showPriceInButton vyžaduje variant');
          }
          // Oddělovač „•“ dělá theme CSS: .product__submit__add .product__price--regular:before
          const priceHtml = this.formatVariantPrice(variant);
          this.atcTextEl.innerHTML =
            this.config.addToCartLabel +
            '<span data-product-price class="product__price--regular">' +
            priceHtml +
            '</span>';
        } else {
          this.atcTextEl.textContent = this.config.addToCartLabel;
        }
      } else if (mode === 'sold_out') {
        this.atcTextEl.textContent = this.config.soldOutLabel;
      } else {
        this.atcTextEl.textContent = this.config.selectVariantLabel;
      }
      this.syncStickyAtcBar();
    }

    clearError() {
      if (this.errorEl) {
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
      }
    }

    showError(message) {
      if (!this.errorEl) {
        throw new Error(message);
      }
      this.errorEl.hidden = false;
      this.errorEl.textContent = message;
    }

    updatePartialLabel() {
      if (!this.selectedLabelEl) {
        return;
      }

      const fieldLabels = this.config.combinationLabels;
      if (!fieldLabels || typeof fieldLabels !== 'object') {
        throw new Error('gelato-poster-configurator: chybí combinationLabels v config');
      }
      ['design', 'frame', 'orientation', 'size', 'horizontal', 'vertical'].forEach(function (key) {
        if (!fieldLabels[key]) {
          throw new Error('gelato-poster-configurator: chybí combinationLabels.' + key);
        }
      });

      const parts = [];
      if (this.designValue) {
        parts.push(displayLabel(this.config, this.designValue));
      }
      if (this.frameValue) {
        if (!Object.prototype.hasOwnProperty.call(this.config.valueDisplayLabels, this.frameValue)) {
          throw new Error('gelato-poster-configurator: chybí CS label pro rám: ' + this.frameValue);
        }
        parts.push(displayLabel(this.config, this.frameValue));
      }
      if (this.sizeCode) {
        const sizeOptionValue = this.selections[this.sizeIndex];
        if (sizeOptionValue) {
          const sizeParts = parseOrientationSizeParts(sizeOptionValue, fieldLabels);
          parts.push(sizeParts.orientationLabel + ' ' + sizeParts.sizeLabel);
        } else {
          parts.push(displayLabel(this.config, this.sizeCode));
        }
      }

      const summaryText = parts.join(' | ');
      const badgeText = parts.join(' · ');
      this.selectedLabelEl.textContent = summaryText;
      const hasContent = parts.length > 0;
      if (this.selectionSummaryEl) {
        this.selectionSummaryEl.classList.toggle('is-visible', hasContent);
        this.selectionSummaryEl.hidden = !hasContent;
      }
      if (this.galleryComboBadge) {
        if (this.galleryComboTextEl) {
          this.galleryComboTextEl.textContent = badgeText;
        }
        if (hasContent) {
          this.syncStickyChromeInlinePad();
        }
        this.galleryComboBadge.classList.toggle('is-visible', hasContent);
        this.galleryComboBadge.hidden = !hasContent;
        if (hasContent) {
          this.cachedBadgeHeight =
            Math.round(this.galleryComboBadge.offsetHeight) || 0;
        } else {
          this.cachedBadgeHeight = 0;
        }
      }
    }

    syncInventoryCountdown() {
      const wrapper = this.root.closest('[data-product]')?.querySelector('[data-variant-countdown-wrapper]');
      if (!wrapper) {
        return;
      }

      wrapper.removeAttribute('hidden');

      if (!this.isComplete()) {
        wrapper.classList.add('gelato-poster-countdown--reserved');
        return;
      }

      const variant = findVariant(this.product, this.selections);
      if (!variant || !variant.available) {
        wrapper.classList.add('gelato-poster-countdown--reserved');
        return;
      }

      wrapper.classList.remove('gelato-poster-countdown--reserved');
    }

    syncFromSelections() {
      this.setActiveButtons();
      this.selections.option1 = null;
      this.selections.option2 = null;
      this.selections.option3 = null;

      if (!this.isComplete()) {
        this.syncHiddenInputs(false);
        this.setVariantSelected(false);
        this.showProductGallery();
        this.clearPreview();
        this.disableAddToCart();
        this.updatePartialLabel();
        this.updateProductPriceDisplay(null);
        this.clearError();
        this.syncInventoryCountdown();
        return;
      }

      const sizeOptionValue = this.resolveOrientationSizeValue(
        this.designValue,
        this.frameValue,
        this.sizeCode
      );

      if (!sizeOptionValue) {
        this.setVariantSelected(false);
        this.showProductGallery();
        this.clearPreview();
        this.disableAddToCart();
        this.updateProductPriceDisplay(null);
        this.showError(
          'Varianta nenalezena pro: ' +
            [this.designValue, this.frameValue, this.sizeCode].join(' / ')
        );
        this.syncInventoryCountdown();
        return;
      }

      this.selections[this.sizeIndex] = sizeOptionValue;
      this.selections[this.frameIndex] = this.frameValue;
      this.selections[this.designIndex] = this.designValue;

      const variant = findVariant(this.product, this.selections);
      if (!variant) {
        this.setVariantSelected(false);
        this.showProductGallery();
        this.clearPreview();
        this.disableAddToCart();
        this.updateProductPriceDisplay(null);
        this.showError(
          'Varianta nenalezena pro: ' +
            [sizeOptionValue, this.frameValue, this.designValue].join(' / ')
        );
        this.syncInventoryCountdown();
        return;
      }

      // Desktop: varianta vpravo, hero beze změny. Mobil: varianta do hero.
      this.clearPreview();
      this.setVariantSelected(true);
      this.promoteVariantSide(variant);
      this.enableAddToCart(variant);
      this.updatePartialLabel();
      this.updateProductPriceDisplay(variant);
      if (!variant.available) {
        this.showError('Vybraná varianta není skladem.');
      } else {
        this.clearError();
      }
      this.syncInventoryCountdown();

      const self = this;
      requestAnimationFrame(function () {
        self.syncHiddenInputs(true);
        // Theme ProductForm po change přepíše ATC text / cenu — znovu doplň.
        if (self.lastEnabledVariant) {
          self.setAddToCartLabel(
            self.lastEnabledVariant.available ? 'add' : 'sold_out',
            self.lastEnabledVariant
          );
          self.updateProductPriceDisplay(self.lastEnabledVariant);
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-gelato-poster-configurator]').forEach(function (root) {
      if (root.dataset.initialized === 'true') {
        return;
      }
      root.dataset.initialized = 'true';
      new GelatoPosterConfigurator(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
